document.addEventListener('DOMContentLoaded', () => {
  const scrollButtons = document.querySelectorAll('.btn--scroll');

  /**
   * Initialize swiper
   *
   * @param {object} Swiper swiper class object
   */
  const initFaqLinksSlider = (Swiper) => {
    const swiperContainer = document.querySelector('.faq-links-swiper');
    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 8,
      watchOverflow: false,
      loop: false,
      allowSlideNext: true,
      allowSlidePrev: true,
      breakpoints: {
        1010: {
          allowSlideNext: false,
          allowSlidePrev: false,
        },
      },
    };
    if (swiperContainer && Swiper) {
      // eslint-disable-next-line no-unused-vars
      const qualitySwiper = new Swiper(swiperContainer, swiperOptions);
    }
  };

  /**
   * Smooth scroll to the target section with an offset from the top.
   *
   * @param {Event} event - The click event.
   */
  function smoothScroll(event) {
    event.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  scrollButtons.forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('.faq-links-swiper').querySelector('.active')?.classList.remove('active');
      button.classList.add('active');
    });

    button.addEventListener('click', smoothScroll);
  });

  let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
  window.addEventListener(
    'scroll',
    function handleScroll() {
      const scrollTopPosition = window.scrollY || document.documentElement.scrollTop;
      if (scrollTopPosition < lastScrollTop) {
        if (this.window.scrollY < 100) {
          document.querySelector('.btn--scroll.active')?.classList.remove('active');
          scrollButtons[0].classList.add('active');
        }
      }
      lastScrollTop = scrollTopPosition <= 0 ? 0 : scrollTopPosition;
    },
    false
  );
  window.LoadSwiper.then((module) => {
    initFaqLinksSlider(module.Swiper);
  });
});
